import { Tracking } from './Tracking';

export enum SCTrackStages {
    ACCEPT = 'accept',
    CONFIRM = 'confirm',
    DENY = 'deny',
    SHOW = 'show',
    CLOSE = 'close',
}

export default class ShortcutTracking {
    public static track(stage: SCTrackStages) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: `Shortcut_${stage}`,
        });
    }
}
